import { Info, CategoryOutlined } from "@mui/icons-material";

export const tabs = [
  {
    icon: <Info />,
    entity: "detail",
    label: "Detalhes",
  },
  {
    icon: <CategoryOutlined />,
    entity: "process_category",
    label: "subCategorias",
  },
];
